<template>
    <div>
        <v-card class="blue accent-3 ma-16">

        
        <h1 class="text-center text-uppercase font-weight-light mt-5 mb-4 white--text">Performance Reviews</h1>

        <v-layout row wrap>

            <v-flex xs12 sm6 class="ml-8">
                <v-select 
                    label="Select a Position to Evaluate"
                    :items="reviewTypes"
                    v-model="position"
                    clearable
                    dark
                ></v-select>
            </v-flex>

            <v-flex xs12 class="ml-8 mr-8">
                <v-card class="blue accent-2">
                    <v-card-title class="white--text">Scoring Key</v-card-title>

                    <v-divider class="ma-2 "></v-divider>

                    <v-layout row wrap class="ma-8">
                        <v-flex xs1></v-flex>

                        <v-flex xs2>
                            <h3 class="white--text">1 = Poor</h3>
                        </v-flex>

                        <v-flex xs2>
                            <h3 class="white--text">2 = Poor</h3>
                        </v-flex>

                        <v-flex xs2>
                            <h3 class="white--text">3 = Poor</h3>
                        </v-flex>

                        <v-flex xs2>
                            <h3 class="white--text">4 = Poor</h3>
                        </v-flex>

                        <v-flex xs2>
                            <h3 class="white--text">5 = Poor</h3>
                        </v-flex>

                        <v-flex xs1></v-flex>


                    </v-layout>

                </v-card>
            </v-flex>

        </v-layout>

        </v-card>


        <v-layout row wrap v-if="position=='Area Manager'">
            
            <areaManager/>
            
        </v-layout>


        <v-layout row wrap v-if="position=='Assistant Manager'">

            <assistantManager />
            
        </v-layout>


        <v-layout row wrap v-if="position=='Client Services Manager'">

            <clientServicesManager />
            
        </v-layout>


        <v-layout row wrap v-if="position=='Compliance Manager'">

            <complianceManager />
            
        </v-layout>


        <v-layout row wrap v-if="position=='Direct Care Associate'">

            <directCareAssociate />
            
        </v-layout>


        <v-layout row wrap v-if="position=='House Manager'">

            <houseManager />
            
        </v-layout>


        <v-layout row wrap v-if="position=='Human Resource Manager'">

            <humanResourceManager />
            
        </v-layout>


        <v-layout row wrap v-if="position=='Medical Assistant'">

            <medicalAssistant />
            
        </v-layout>


        <v-layout row wrap v-if="position=='Medical Manager'">

            <medicalManager />
            
        </v-layout>


        <v-layout row wrap v-if="position=='Program Coordinator'">

            <programCoordinator />
            
        </v-layout>


        <v-layout row wrap v-if="position=='Shift Lead'">

            <shiftLead />
            
        </v-layout>

    </div>
</template>
<script>
import areaManager from "@/components/performanceReviews/AreaManager.vue"
import assistantManager from "@/components/performanceReviews/AssistantManager.vue"
import clientServicesManager from "@/components/performanceReviews/ClientServicesManager.vue"
import complianceManager from "@/components/performanceReviews/ComplianceManager.vue"
import directCareAssociate from "@/components/performanceReviews/DirectCareAssociate.vue"
import houseManager from "@/components/performanceReviews/HouseManager.vue"
import humanResourceManager from "@/components/performanceReviews/HumanResource.vue"
import medicalAssistant from "@/components/performanceReviews/MedicalAssistant.vue"
import medicalManager from "@/components/performanceReviews/MedicalManager.vue"
import programCoordinator from "@/components/performanceReviews/ProgramCoordinator.vue"
import shiftLead from "@/components/performanceReviews/ShiftLead.vue"


export default {
    components: { 
        areaManager,
        assistantManager,
        clientServicesManager,
        complianceManager,
        directCareAssociate,
        houseManager,
        humanResourceManager,
        medicalAssistant,
        medicalManager,
        programCoordinator,
        shiftLead
         },
    data: () => ({
        reviewTypes: [
            "Area Manager",
            "Assistant Manager",
            "Client Services Manager",
            "Compliance Manager",
            "Direct Care Associate",
            "House Manager",
            "Human Resource Manager",
            "Medical Assistant",
            "Medical Manager",
            "Program Coordinator",
            "Shift Lead"
        ],
        position: "",
        employeeName: "",
        employeeDate: "",
        individual1: 0,
        individual2: 0,
        individual3: 0,
        individual4: 0,
        individual5: 0,
        staffing1: 0,
        staffing2: 0,
        staffing3: 0,
        staffing4: 0,
        staffing5: 0,
        security1: 0,
        security2: 0,
        program1: 0,
        program2: 0,
        program3: 0,
        program4: 0,
        transportation1: 0,
        transportation2: 0,
        transportation3: 0,
        medical1: 0,
        medical2: 0,
        medical3: 0,
        goals1: 0,
        goals2: 0,
        goals3: 0,
        goals4: 0,
        goals5: 0,
        finances1: 0,
        finances2: 0,
        finances3: 0,
        finances4: 0,
        finances5: 0,
        personal1: 0,
        personal2: 0,
        personal3: 0,
        personal4: 0,
        personal5: 0,
        scoreTotal: 0,
        improvement: "",
        successes: "",
        programDirector: "",
        programDate: "",
    }),

    methods: {
        updateScore () {
            this.scoreTotal = (this.individual1 + this.individual2 + this.individual3 + this.individual4 + this.individual5 + this.staffing1 + this.staffing2 + this.staffing3 + this.staffing4 + this.staffing5 + this.security1 + this.security2 + this.program1 + this.program2 + this.program3 + this.program4 + this.transportation1 + this.transportation2 + this.transportation3 + this.medical1 + this.medical2 + this.medical3 + this.goals1 + this.goals2 + this.goals3 + this.goals4 + this.goals5 + this.finances1 + this.finances2 + this.finances3 + this.finances4 + this.finances5 + this.personal1 + this.personal2 + this.personal3 + this.personal4 + this.personal5) / parseInt(37)
        }
    }
}
</script>